import { render } from "./ModalPasswordForm.vue?vue&type=template&id=b374c5b6"
import script from "./ModalPasswordForm.vue?vue&type=script&lang=js"
export * from "./ModalPasswordForm.vue?vue&type=script&lang=js"
script.render = render

export default script